<div class="sam-form-row">
   <div class="k-form-field sam-form-control sam-form-control-full-width">
      <div kendoTooltip>
         <kendo-dropdownlist
            class="k-form-field sam-form-control"
            fxFlex="1 1 auto"
            [data]="headsetManufacturers$ | async"
            textField="value"
            valueField="value"
            [valuePrimitive]="false"
            [value]="selectedManufacturer$ | async"
            (selectionChange)="onSelectionChange($event)"
         >
            <ng-template kendoDropDownListValueTemplate kendoDropDownListItemTemplate let-dataItem>
               {{ dataItem?.translationKey | translate }}
            </ng-template>
         </kendo-dropdownlist>

         <div class="side-control">
            <button kendoButton>
               <fa-icon [icon]="(isSelectedHeadsetAttached$ | async) ? deviceFoundIcon : deviceNotFoundIcon"></fa-icon>
            </button>
         </div>
      </div>
   </div>
</div>
